import React from 'react';
import Header, { HeaderLeft } from '../../../layout/Header/Header';
import CommonHeaderRight from './CommonHeaderRight';

const FeaturedLimitHeader = () => {
	return (
		<Header>
			<HeaderLeft className='h4 mb-0 fw-bold'>Featured Massage-center Limit</HeaderLeft>
			<CommonHeaderRight />
		</Header>
	);
};

export default FeaturedLimitHeader;
